import './defaultUserIcon.css';

export default function DefaultUserIcon() {
    return (
        <div>
            <svg width="62" height="62" viewBox="0 0 62 62">
                <g id="Group_702" data-name="Group 702" transform="translate(-19 -20)">
                    <circle id="Ellipse_43" data-name="Ellipse 43" cx="31" cy="31" r="31" transform="translate(19 20)" fill="#8ce68c"/>
                    <path id="Icon_material-round-person" data-name="Icon material-round-person" d="M18,18a6,6,0,1,0-6-6A6,6,0,0,0,18,18Zm0,3c-4.005,0-12,2.01-12,6v1.5A1.5,1.5,0,0,0,7.5,30h21A1.5,1.5,0,0,0,30,28.5V27C30,23.01,22.005,21,18,21Z" transform="translate(32 33)" fill="#39505d"/>
                </g>
            </svg>
        </div>
    )
}